import React from 'react';
import { Mail, Calendar, ChevronUp, ChevronDown } from 'lucide-react';

const DraggableUserQuestion = ({
  question,
  index,
  dragProps,
  isDragging,
  isDraggedOver,
  onMoveUp,
  onMoveDown,
  isFirst,
  isLast
}) => {
  return (
    <div 
      {...dragProps}
      className={`border border-secondary-border rounded-lg bg-secondary transition-colors cursor-grab active:cursor-grabbing ${
        isDragging 
          ? 'opacity-50 scale-95 bg-primary/10 border-2 border-primary/30' 
          : isDraggedOver 
            ? 'bg-primary/5 border-2 border-primary/20' 
            : 'hover:bg-secondary/50 hover:border-primary/20'
      }`}
      title="Drag to reorder question"
    >
      <div className="p-4">
        <div className="flex items-center gap-4">
          {/* Question Number */}
          <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
            <span className="text-white font-bold text-sm">
              {index + 1}
            </span>
          </div>

          {/* Question Content */}
          <div className="flex-1 min-w-0">
            <div className="text-foreground text-sm break-words">
              <span className="font-semibold">
                {question.submitted_by_name}
              </span>
              <span className="text-muted-foreground mx-2">•</span>
              <span className="text-primary font-medium">
                {question.submitted_by_relation}
              </span>
              <span className="text-muted-foreground mx-2">•</span>
              <span>
                {question.question}
              </span>
            </div>
          </div>

          {/* Meta Info */}
          <div className="flex items-center gap-4 text-sm text-muted-foreground flex-shrink-0">
            <div className="flex items-center">
              <Mail className="mr-1 text-primary" size={14} />
              <span className="hidden sm:inline">{question.submitted_by}</span>
            </div>
            <div className="flex items-center">
              <Calendar className="mr-1 text-primary" size={14} />
              <span>{new Date(question.created_at).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric'
              })}</span>
            </div>
          </div>

          {/* Up/Down Arrow Controls */}
          <div className="flex flex-col items-center justify-center flex-shrink-0 gap-0 pdf-export-remove">
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onMoveUp();
              }}
              disabled={isFirst}
              className={`p-1 rounded-lg transition-colors ${
                isFirst 
                  ? 'text-muted-foreground/30 cursor-not-allowed' 
                  : 'text-muted-foreground hover:text-primary hover:bg-secondary/50'
              }`}
              title={isFirst ? "Cannot move up (first question)" : "Move up"}
            >
              <ChevronUp className="text-sm" size={16} />
            </button>
            
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onMoveDown();
              }}
              disabled={isLast}
              className={`p-1 rounded-lg transition-colors ${
                isLast 
                  ? 'text-muted-foreground/30 cursor-not-allowed' 
                  : 'text-muted-foreground hover:text-primary hover:bg-secondary/50'
              }`}
              title={isLast ? "Cannot move down (last question)" : "Move down"}
            >
              <ChevronDown className="text-sm" size={16} />
            </button>
          </div>
        </div>
      </div>

      {/* Drop Indicator */}
      {isDraggedOver && (
        <div className="absolute inset-0 border-2 border-dashed border-primary/50 rounded-lg pointer-events-none pdf-export-remove">
          <div className="absolute top-2 left-2 bg-primary text-white px-2 py-1 rounded-lg text-xs font-medium">
            Drop here to reorder
          </div>
        </div>
      )}
    </div>
  );
};

export default DraggableUserQuestion; 